import { composables } from "@orange-marmalade/paginate-this";

export const pageActions = composables({
  listId: "part/outgoingQuoteLineItems"
});



// WEBPACK FOOTER //
// ./app/modules/parts/actions/outgoingQuotes.js